import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

// layout
import PageLayout from "./PageLayout";

const transitionVariants = {
	initial: {
		opacity: 0,
		x: -100,
	},
	animate: {
		opacity: 1,
		x: 0,
	},
	exit: {
		opacity: 100,
		x: -100,
	},
	transition: {
		duration: 0.5,
		when: "beforeChildren",
		staggerChildren: 0.5,
	},
};

const AnimatedLayout = () => {
	const { pathname } = useLocation();

	return (
		<PageLayout>
			<motion.div
				key={pathname}
				transition="transition"
				className="mx-auto container px-2">
				<Outlet />
			</motion.div>
		</PageLayout>
	);
};

export default AnimatedLayout;
